

export enum ActivityType {
  PLATFORM_ONLINE_ACTIVITY = 0,
  MY_LIBRARY_VIDEO = 1,
  PLATFORM_DIAGNOSTICS = 2,
  MY_LIBRARY_LINK = 3,
  MY_LIBRARY_TASK = 4,
  MY_LIBRARY_WORKSHEET = 5,
  PLATFORM_VIDEO = 6,
  PLATFORM_WORKSHEET = 7,
  PLATFORM_SUMMATIVE = 8,
  PLATFORM_GAMES = 9,
  TUTOR_LIBRARY_ITEM = 10,
  LLL = 11,
  ONETIME = 12,
  DIAGNOSTICS_FLOW = 13,
  /** Skill Builder: a remediation worksheet assigned off a diagnostic. */
  SKILLBUILDER = 14,
  /** English full diagnostics (edt_* tables). Math diagnostics stay on DIAGNOSTICS_FLOW. */
  ENGLISH_DIAGNOSTICS = 15,
  /**
   * English Skill Builder: online AQ questions assigned off an English diagnostic gap.
   *
   * NOT a variant of SKILLBUILDER (14) despite the name. 14 is a PDF worksheet from S3 that a
   * tutor marks by hand; this is a node of questions the student answers in the app and that
   * auto-mark, the same machinery the diagnostic itself uses. The names are paired because the
   * two play the same ROLE - remediation off a diagnostic - not because they share a path.
   */
  ENGLISH_SKILLBUILDER = 16
}

// export type LessonActivity = {
//   pk_lesson_activity_id: number;
//   pk_lesson_activity_key: string;
//   fk_activity_node_id: number;
//   activity_type: number;
//   status: number;
//   fk_sub_id: number;
//   fk_sest_key: string; // this is session key, not session time key
// }

export class LessonActivityModel {
  constructor(private data: LessonActivity) {
  }

  isCompleted(){
    return this.data.status === 1;
  }

  getCoinsEarned() {
    return this.data.coins_earned;
  }

}



export type ActivityInfo = {
  pk_lesson_activity_id: number,
  pk_lesson_activity_key: string,
  fk_student_key: string,
  fk_sub_id: number,
  fk_sest_key: string,
  fk_lesson_key: string,
  fk_activity_node_id: number,
  activity_ref_id?: string,
  activity_type: number,
  sort_order: number,
  fk_tut_key: string,
  status: number,
  is_deleted: number,
  marked_for_homework: number,
  created_on: string,
  updated_on: string | null,
  tutor_comments: string | null,
  fk_activity_level_id: number,
  is_move: number,
  fk_move_ses_key: string | null,
  is_skip_complete: number,
  coins_earned: number | null,
  subject_id: number,
  subject_name: string,
  subject_date_added: string,
  subject_date_updated: string,
  sub_abbreviation: string,
  sub_details: string,
  fk_cent_key: string,
  created_by: string,
  updated_by: string,
  visibility: number,
  tut_clock_is_active: number,
  lesson_tutor_message: string | null,
  homework_tutor_message: string | null
}



export type LessonActivity = {
  pk_lesson_activity_id: number,
  pk_lesson_activity_key: string,
  fk_student_key: string,
  fk_sub_id: number,
  fk_sest_key: string, // this is session key, not session time key
  fk_lesson_key: string,
  fk_activity_node_id: number,
  activity_ref_id?: string,
  activity_type: number,
  sort_order: number,
  fk_tut_key: string,
  status: number,
  is_deleted: number,
  marked_for_homework: number,
  created_on: string,
  updated_on: string,
  tutor_comments: string | null,
  fk_activity_level_id: number,
  is_move: number,
  fk_move_ses_key: string | null,
  is_skip_complete: number,
  coins_earned: number,
}

export type ActivityAttempt = {
  pk_attempt_id: number,
  fk_student_key: string,
  fk_sest_key: string,
  fk_lesson_key: string,
  fk_question_id: number | null,
  message: string | null,
  points_obtained: number,
  attempt_status: number,
  atempt_count: number,
  fk_sub_id: number,
  student_answer: string | null,
  answer_reason: string | null,
  answer_confident: string | null,
  fk_lesson_activity_key: string,
  fk_lesson_activity_question_key: string | null,
  submitted_on: number, // duration
  created_on: string,
  updated_on: string | null,
  is_deleted: number,
  part_id: number
}